import { cn } from "@newxsystems/shared";
import type { BlockColumnCount, BlockColumnSpan } from "@newxsystems/types";
import { useContext } from "react";
import { ResponsiveBlockGridColumnContext } from "../ResponsiveBlockGrid/ResponsiveBlockGrid";
import type { IResponsiveBlockGridItemProps } from "./ResponsiveBlockGridItem.props";

const spanClasses: Record<BlockColumnCount, Record<BlockColumnSpan, string>> = {
  1: {
    1: "col-span-1",
    2: "col-span-1",
    3: "col-span-1",
    4: "col-span-1",
  },
  2: {
    1: "col-span-1",
    2: "col-span-1 md:col-span-2",
    3: "col-span-1 md:col-span-2",
    4: "col-span-1 md:col-span-2",
  },
  3: {
    1: "col-span-1",
    2: "col-span-1 md:col-span-2",
    3: "col-span-1 md:col-span-3",
    4: "col-span-1 md:col-span-3",
  },
  4: {
    1: "col-span-1",
    2: "col-span-1 md:col-span-2",
    3: "col-span-1 md:col-span-3",
    4: "col-span-1 md:col-span-3 lg:col-span-4",
  },
};

export const ResponsiveBlockGridItem = ({
  children,
  className,
  span = 1,
  ...attributes
}: IResponsiveBlockGridItemProps) => {
  const columnCount = useContext(ResponsiveBlockGridColumnContext);
  const authoredSpan = span ?? 1;

  return (
    <div
      className={cn("min-w-0", spanClasses[columnCount][authoredSpan], className)}
      {...attributes}
    >
      {children}
    </div>
  );
};

ResponsiveBlockGridItem.displayName = "Shared::ResponsiveBlockGridItem";
